import React from 'react';

const Education = () => {
    return (
        <div className="pb-3">
                 <h1 className="text-center py-5 ">Education & Skills</h1>
                 <div className="row row-cols-lg-2 row-cols-1">
                     <div>
             <div className="col-sm-6">
             <div className="card">
             <div className="card-body">
             <h5 className="card-title">COMPUTER SCIENCE AND ENGINEERING </h5>
             <p className="card-text">BSC honers at National university of Bangladesh .  </p>
             <p>course duration: 2018 to present</p>
             </div>
          </div>
         </div>
             
             <div className="col-sm-6 mt-1">
             <div className="card">
             <div className="card-body">
             <h5 className="card-title">SECONDARY AND HIGHER EDUCATION</h5>
             <p className="card-text">In my secondary program was  science faculty  </p>
             <p>course duration: 2016 to 2018</p>

          </div>
          </div>
         </div>
          </div>
          <div className="">
    <h1>Technology Skills :</h1>
         <div >
         <h1  style={{width:"20px"}}> HTML</h1>
         </div>
          <div className="progress">
         
        <div style={{width:"90%"}}  className="progress-bar  col-sm-6" role="progressbar" aria-valuenow="90" aria-valuemin="90"  aria-valuemax="100"> 90%
       </div>
        </div>
         <div >
         <h1  style={{width:"20px"}}> CSS</h1>
         </div>
          <div className="progress">
         
        <div  style={{width:"85%"}}   className="progress-bar  col-sm-6" role="progressbar" aria-valuenow="90" aria-valuemin="90"  aria-valuemax="100"> 85%
       </div>
        </div>
         <div >
         <h1  style={{width:"20px"}}> javaScript</h1>
         </div>
          <div className="progress">
         
        <div style={{width:"65%"}} className="progress-bar  col-sm-6" role="progressbar" aria-valuenow="90" aria-valuemin="90"  aria-valuemax="100"> 65%
       </div>
        </div>
         <div >
         <h1  style={{width:"20px"}}> REACT </h1>
         </div>
          <div className="progress">
         
        <div style={{width:"85%"}} className="progress-bar  col-sm-6" role="progressbar" aria-valuenow="90" aria-valuemin="90"  aria-valuemax="100"> 85%
       </div>
        </div>
         <div >
         <h1  style={{width:"20px"}}>MONGODB </h1>
         </div>
          <div className="progress">
         
        <div style={{width:"75%"}} className="progress-bar  col-sm-6" role="progressbar" aria-valuenow="90" aria-valuemin="90"  aria-valuemax="100"> 75%
       </div>
        </div>

     </div>
                </div>
            </div>
     
    );
};

export default Education;